var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card, LILAC_600, getTestId, isLastItem } from '@airtel/air-design-system';
import { Fragment } from 'react';
import { TrackOrderCardComponent } from './components/track-order-card';
import { getTrackOrderCardWidgetStyles } from './TrackOrderCardWidgetStyles';
export var TrackOrderCardWidgetComponent = props => {
  var _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    _props$listStyle = props.listStyle,
    listStyle = _props$listStyle === void 0 ? {} : _props$listStyle,
    _props$scrollLinkStyl = props.scrollLinkStyle,
    scrollLinkStyle = _props$scrollLinkStyl === void 0 ? {} : _props$scrollLinkStyl,
    style = props.style,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["list", "listStyle", "scrollLinkStyle", "style", "onUserAction"]);
  var trackOrderCardWidgetStyles = getTrackOrderCardWidgetStyles();
  return _jsx(Card, Object.assign({
    showShadow: false,
    style: [style, trackOrderCardWidgetStyles.cardContainer],
    borderColor: LILAC_600
  }, restProps, getTestId(props === null || props === void 0 ? void 0 : props.testID), {
    children: list === null || list === void 0 ? void 0 : list.map((item, index) => _jsx(Fragment, {
      children: _jsx(TrackOrderCardComponent, {
        index: index,
        isLastItem: isLastItem(props === null || props === void 0 ? void 0 : props.list, index),
        item: item,
        list: list,
        listStyle: listStyle,
        scrollLinkStyle: scrollLinkStyle,
        onUserAction: onUserAction
      })
    }, "trackOrderCard_" + index))
  }));
};
TrackOrderCardWidgetComponent.genericRendererKey = 'AirTrackOrderCardWidget';